<div class="trinka_cloud_wrap">

    <div class="trinka_cloud_wrap1">
        <!-- <div class="cloud_top_banners">
            <div class="container">
                <div class="row">
                    <div class="col-lg-7">
                        <div class="trinka_cloud_banner_text">
                            <h1>Citation Checker</h1>
                            <h2>Strengthen Your <br/>Research Argumentation</h2>
                            <p>Trinka Citation Checker performs automated citation analysis to identify citations that can make your research premise and argumentation weaker and helps you cite credible, strong citations for your paper. </p>
                            <a href="https://cloud.trinka.ai/signup?_rg=GB" id="autoEditGetStart" target="_blank" rel="noopener noreferrer">Check Now</a>
                        </div>
                    </div>
                    <div class="col-lg-5">
                        <div class="trinka_cloud_banner_img text-center" style="text-align: center !important;">
                            <img src="../../../assets/images/Reference-Quality-Check.png" alt="Citation Checker">
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
        <section class="mainTopBanner">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="topBannerWrapper align-items-center">
                            <div class="top-banner-left">
                                <h1>Citation Checker</h1>
                                <h2>Strengthen Your Research Argumentation</h2>
                                <p>Trinka’s Citation Quality Checker detects citation risks from retracted, hallucinated, and predatory sources so your manuscript stands strong before submission.
                                </p>
                                <div class="btn-group">
                                    <a href="https://cloud.trinka.ai/signup?_rg=GB" class="filled-btn" target="_blank" rel="noopener noreferrer">Get Started</a>
                                </div>
                            </div>
                            <div class="top-banner-right">
                                <img src="assets/images/features/features-page/citation-quality-check.png" alt="Citation Checker" class="img-fluid w-100 h-auto">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>

    <section class="section-pd list-wrapper-style-2 cdp-light-purple">
        <div class="trinka_container container">
            <div class="row justify-content-center">
                <div class="col-md-12 col-lg-12">
                    <div class="trinka-title mb-0 text-center">
                        <h2>Fake Citations Are Rising</h2>
                        <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                        <p>Is Your Research at Risk?</p>
                    </div>
                </div>
            </div>
            <div class="row justify-content-center match-box">
                <div class="col-lg-4 col-sm-4 col-12 dflex">
                    <div class="cdp-stat c-card">
                        <span>12x</span>
                        <p>Increase in fabricated citations in biomedical literature in just two years</p>
                        <small>Nature / Lancet analysis, 2026</small>
                    </div>
                </div>
                <div class="col-lg-4 col-sm-4 col-12 dflex">
                    <div class="cdp-stat c-card">
                        <span>30%</span>
                        <p>of ChatGPT citations do not exist. </p>
                        <small>The American Economist, 2024</small>
                    </div>
                </div>
                <div class="col-lg-4 col-sm-4 col-12 dflex">
                    <div class="cdp-stat c-card">
                        <span>10X</span>
                        <p>Increase in fabricated reference since AI writing tools became mainstream</p>
                        <small>Topaz et al., The Lancet, 2026</small>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <p class=" mt-30 text-center">Verify Your Citations Before Submission</p>
                    <div class="btn-group justify-content-center">
                        <a href="https://cloud.trinka.ai/signup?_rg=GB" class="filled-btn" target="_blank">Try Trinka's Citation Quality Check</a>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <div class="howItWorks section-pd list-wrapper-style-2" #viewVideo>
        <div class="trinka_container">
            <div class="row align-items-center">
                <div class="col-lg-6">
                    <div class="list-wrapper-image">
                        <a href="" data-toggle="modal" data-target="#wordPluginPopup" id="VewiVideoSection">
                            <img src=".././../../assets/images/yt-thumbnail/citation-video.webp" loading="lazy" decoding="async" alt="citation video" class="img-fluid eposter-img">
                        </a>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="list-wrapper-content-2">
                        <div class="trinka-title mb-0">
                            <h2>See How It Works</h2>
                            <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                            <p>See how Trinka Citation Checker works and get started in no time.</p>
                            <p>The easy walk-through video will help you get the most out of this feature.</p>
                            <p>Have more questions? Browse through our FAQs <a style="color: #0000ff;" (click)="scroll(target)" class="link text-link">here</a>.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="cloud_key_features section-pd list-wrapper-style-2">
        <div class="trinka_container">
            <div class="row justify-content-center">
                <div class="col-md-11 col-lg-10">
                    <div class="trinka-title mb-0 text-center">
                        <h2>Key Features of Trinka Citation Checker </h2>
                        <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                        <p>Trinka Citation Checker identifies various quality risks for a robust citation analysis that
                            lets you improve your citation list and strengthen your research argumentation.</p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-6 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards bt-none">
                        <div class="media gap-15">
                            <div class="media-left">
                                <img src="../../../assets/images/Retracted-References.png" loading="lazy" decoding="async" alt="Retracted">
                            </div>
                            <div class="media-body">
                                <h3>Retracted Citations</h3>
                                <p>Identify studies that have been recalled after publication and avoid peer review critique.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards">
                        <div class="media gap-15">
                            <div class="media-left">
                                <img src="../../../assets/images/Non-standard-References.png" loading="lazy" decoding="async" alt="non standard">
                            </div>
                            <div class="media-body">
                                <h3>Unverified Citations</h3>
                                <p>Improve your citation credibility by eliminating citations that are not found in citation databases.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards bt-1">
                        <div class="media gap-15">
                            <div class="media-left">
                                <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M20 24.75H20.006M20 18.75V22.5M14 21.939C14 27.7042 19.1885 29.7292 19.9153 29.985C19.9718 30.005 20.0283 30.005 20.0848 29.985C20.813 29.7375 26 27.7635 26 21.9397V16.728C26.0002 16.6609 25.9779 16.5958 25.9367 16.5429C25.8955 16.49 25.8378 16.4525 25.7728 16.4362L20.0728 15.009C20.025 14.997 19.975 14.997 19.9273 15.009L14.2273 16.4362C14.1622 16.4525 14.1045 16.49 14.0633 16.5429C14.0221 16.5958 13.9998 16.6609 14 16.728V21.939Z" stroke="#763393" stroke-width="0.976431" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M35 3.5C35.2761 3.5 35.5 3.27614 35.5 3C35.5 2.72386 35.2761 2.5 35 2.5V3V3.5ZM35 3V2.5H7V3V3.5H35V3ZM7 7V7.5H35V7V6.5H7V7ZM5 5H4.5C4.5 6.38071 5.61929 7.5 7 7.5V7V6.5C6.17157 6.5 5.5 5.82843 5.5 5H5ZM7 3V2.5C5.61929 2.5 4.5 3.61929 4.5 5H5H5.5C5.5 4.17157 6.17157 3.5 7 3.5V3Z" fill="#4D4D4D"/>
                                    <path d="M35.5 7.03077C35.5 6.75463 35.2761 6.53077 35 6.53077C34.7239 6.53077 34.5 6.75463 34.5 7.03077H35H35.5ZM35 37V37.5H35.5V37H35ZM35 7.03077H34.5V37H35H35.5V7.03077H35ZM35 37V36.5H9V37V37.5H35V37ZM5 33H5.5V5H5H4.5V33H5ZM9 37V36.5C7.067 36.5 5.5 34.933 5.5 33H5H4.5C4.5 35.4853 6.51472 37.5 9 37.5V37Z" fill="#4D4D4D"/>
                                    <path d="M7 5H31.5" stroke="#4D4D4D" stroke-linecap="round"/>
                                </svg> 
                            </div>
                            <div class="media-body">
                                <h3>Predatory Journal Detection</h3>
                                <p>Flags citations from potentially predatory journals to protect your manuscript’s credibility.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards bt-1">
                        <div class="media gap-15">
                            <div class="media-left">
                                <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M5.05056 19.1919H12.9293H20.8081M5.05056 22.4242H12.9293H20.8081M5.05056 25.6566H12.9293H20.8081M5.05056 28.8889H12.9293H20.8081M23.2324 37.7273V11.1616C23.2324 10.9106 23.0289 10.7071 22.7778 10.7071H2.27278C2.02174 10.7071 1.81824 10.9106 1.81824 11.1616V37.7273C1.81824 37.9783 2.02175 38.1818 2.27278 38.1818H22.7778C23.0289 38.1818 23.2324 37.9783 23.2324 37.7273Z" stroke="#4D4D4D" stroke-linecap="round"/>
                                    <path d="M35.4512 16.4596C35.7273 16.4614 35.9527 16.239 35.9545 15.9629C35.9563 15.6867 35.7339 15.4614 35.4578 15.4596L35.4545 15.9596L35.4512 16.4596ZM35.4512 19.6919C35.7273 19.6937 35.9527 19.4713 35.9545 19.1952C35.9563 18.9191 35.7339 18.6937 35.4578 18.6919L35.4545 19.1919L35.4512 19.6919ZM25.4811 18.6261C25.205 18.6243 24.9797 18.8466 24.9778 19.1228C24.976 19.3989 25.1984 19.6242 25.4745 19.6261L25.4778 19.1261L25.4811 18.6261ZM25.4811 15.3938C25.205 15.3919 24.9797 15.6143 24.9778 15.8904C24.976 16.1666 25.1984 16.3919 25.4745 16.3937L25.4778 15.8937L25.4811 15.3938ZM25.4811 21.8584C25.205 21.8566 24.9797 22.079 24.9778 22.3551C24.976 22.6312 25.1984 22.8566 25.4745 22.8584L25.4778 22.3584L25.4811 21.8584ZM35.4512 22.9242C35.7273 22.926 35.9527 22.7037 35.9545 22.4275C35.9563 22.1514 35.7339 21.9261 35.4578 21.9242L35.4545 22.4242L35.4512 22.9242ZM25.4811 25.0907C25.205 25.0889 24.9797 25.3113 24.9778 25.5874C24.976 25.8636 25.1984 26.0889 25.4745 26.0907L25.4778 25.5907L25.4811 25.0907ZM35.4512 26.1565C35.7273 26.1584 35.9527 25.936 35.9545 25.6599C35.9563 25.3837 35.7339 25.1584 35.4578 25.1566L35.4545 25.6566L35.4512 26.1565ZM16.9191 7.47473V7.97473H37.4242V7.47473V6.97473H16.9191V7.47473ZM37.4242 34.9495V34.4495H24.1414V34.9495V35.4495H37.4242V34.9495ZM25.4778 19.1261L25.4745 19.6261L35.4512 19.6919L35.4545 19.1919L35.4578 18.6919L25.4811 18.6261L25.4778 19.1261ZM25.4778 15.8937L25.4745 16.3937L35.4512 16.4596L35.4545 15.9596L35.4578 15.4596L25.4811 15.3938L25.4778 15.8937ZM25.4778 22.3584L25.4745 22.8584L35.4512 22.9242L35.4545 22.4242L35.4578 21.9242L25.4811 21.8584L25.4778 22.3584ZM25.4778 25.5907L25.4745 26.0907L35.4512 26.1565L35.4545 25.6566L35.4578 25.1566L25.4811 25.0907L25.4778 25.5907ZM16.4646 10.7071H16.9646V7.92928H16.4646H15.9646V10.7071H16.4646ZM37.8787 7.92928H37.3787V21.2121H37.8787H38.3787V7.92928H37.8787ZM37.8787 21.2121H37.3787V34.4949H37.8787H38.3787V21.2121H37.8787ZM37.4242 34.9495V35.4495C37.9514 35.4495 38.3787 35.0221 38.3787 34.4949H37.8787H37.3787C37.3787 34.4698 37.3991 34.4495 37.4242 34.4495V34.9495ZM37.4242 7.47473V7.97473C37.3991 7.97473 37.3787 7.95438 37.3787 7.92928H37.8787H38.3787C38.3787 7.40209 37.9514 6.97473 37.4242 6.97473V7.47473ZM16.9191 7.47473V6.97473C16.392 6.97473 15.9646 7.4021 15.9646 7.92928H16.4646H16.9646C16.9646 7.95438 16.9442 7.97473 16.9191 7.97473V7.47473Z" fill="#4D4D4D"/>
                                    <path d="M12.3232 9.89899C12.3232 5.0505 15.8707 1.81818 20.2481 1.81818C23.8044 1.81818 26.6731 3.70505 27.6768 6.66666" stroke="#763393" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M24.4443 5.85857L27.6767 6.66665L28.4847 3.43433" stroke="#763393" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                                    
                            </div>
                            <div class="media-body">
                                <h3>Duplicate <br class="d-md-block d-none"/>References</h3>
                                <p>Detect repeated entries in your bibliography to ensure a clean, submission-ready reference list.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards bt-1">
                        <div class="media gap-15">
                            <div class="media-left">
                                <img src="../../../assets/images/Old-References.png" loading="lazy" decoding="async" alt="old reference">
                            </div>
                            <div class="media-body">
                                <h3>Old References</h3>
                                <p>Easily identify papers published long ago to ensure high relevance and validity of your citations.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards bt-1">
                        <div class="media gap-15">
                            <div class="media-left">
                                <img src="../../../assets/images/Overuse.png" loading="lazy" decoding="async" alt="overuse">
                            </div>
                            <div class="media-body">
                                <h3>Journal Overuse</h3>
                                <p>Identify unintentional bias toward a journal and avoid peer review critique by diversifying your citation sources.</p>
                            </div>
                        </div>
                       
                        
                    </div>
                </div>
            </div>
        </div>
    </div>

    
    <div class="cloud_key_features section-pd list-wrapper-style-2" style="background-color: #f3eef6;">
        <div class="trinka_container">
            <div class="row justify-content-center">
                <div class="col-md-11 col-lg-10">
                    <div class="trinka-title mb-0 text-center">
                        <h2>Why Choose Trinka Citation Checker</h2>
                        <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-6 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards bt-none">
                        <div class="media gap-15">
                            <div class="media-left">
                                <img src="../../../../assets/images/languageScore_icon.svg" loading="lazy" decoding="async" alt="Free Score Overview" />
                            </div>
                            <div class="media-body">
                                <h3>Free Score Overview</h3>
                                <p>Generate citation analysis score for free and only pay for the report when needed.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards">
                        <div class="media gap-15">
                            <div class="media-left">
                                <img src="../../../../assets/images/Up-to-date-Repository.png" loading="lazy" decoding="async" alt="Free Score Overview" />
                            </div>
                            <div class="media-body">
                                <h3>Crossref Validation</h3>
                                <p>All your citations are validated against Crossref’s extensive publication repository trusted by publishers and organizations worldwide.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <app-security-section></app-security-section>

    <div class="cloud_key_features section-pd bg-light-purple">
        <div class="trinka_container">
            <div class="row justify-content-center">
                <div class="col-md-11 col-lg-11">
                    <div class="trinka-title mb-0 text-center">
                        <h2>See a Sample Report!</h2>
                        <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                        <p>Explore a sample citation analysis report from Trinka Citation Checker to understand how you can benefit from it for your paper!</p>
                    </div>
                </div>
                <div class="col-12">
                    <div class="btn-group justify-content-center mt-1">
                        <a href="/citation-checker/sample-report" target="_blank" class="filled-btn">View Sample Report</a>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="trinka-banner section-pd-sm">
        <div class="trinka_container">
            <div class="row justify-content-center">
                <div class="col-md-10 col-lg-12">
                    <div class="trinka-title text-center">
                        <h3 class="text-white">Get Your Free Citation Analysis Score Now</h3>
                    </div>
                    <div class="btn-group justify-content-center">
                        <a href="https://cloud.trinka.ai/signup?_rg=GB" class="white-btn" target="_blank" rel="noopener noreferrer">Get Started</a>
                    </div>
                </div>
            </div>  
        </div>
    </div>
    
    <section class="section-pd pb-0">
        <app-credits-info
            [title]="'Citation Checker Uses Credits'"
            [description]="'Citation Analysis scores are free; you only need to pay for the full report. To generate the report, <span>1 credit is used for up to 30 citations</span>. Use free credits or buy more as needed.'"
            [subText]="'Credits are like tokens that let you use several Trinka features as needed.<br/> Users get free credits every month based on the subscription plan. To know more, <a href=\'/features/credits\' class=\'text-link\'>click here</a>.<br/> Additionally, you get up to 64% discount on credit pack purchases.'"
        ></app-credits-info>
    </section>

    <div class="faqQuestionAnwser section-pd" #target>
        <div class="trinka_container">
            <div class="row justify-content-center">
                <div class="col-lg-8 col-md-10">
                    <div class="trinka-title text-center">
                        <h2>Frequently Asked Questions</h2>
                        <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    </div>
                </div>
            </div>
            <div class="faqQuestionsList">
                <div class="accordion" id="faq">
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="faqContainer">
                                <div class="card">
                                    <div class="card-header" id="QuestionOne">
                                        <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionOneContent" aria-expanded="true" aria-controls="QuestionOneContent">
                                            How does Trinka Citation Checker work?</a>
                                    </div>
    
                                    <div id="QuestionOneContent" class="collapse" aria-labelledby="QuestionOne" data-parent="#faq">
                                        <div class="card-body">
                                            <h4>Improve the quality of your citations in 3 simple steps! </h4>
                                            <ol>
                                                <li>Just <a href="https://cloud.trinka.ai/signup" target="_blank" rel="noopener noreferrer">Sign Up</a> for free on Trinka. </li>
                                                <li>Go to the Citation Checker page from the left navigation panel. </li>
                                                <li>Upload your document. You can upload from Google Drive, Dropbox, or your computer. You can also use document already uploaded on Trinka. You will get your report in a few minutes!</li>
                                            </ol>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="QuestionThree">
                                        <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionThreeContent" aria-expanded="true"
                                            aria-controls="QuestionThreeContent">
                                            Does Trinka review citation to paywalled articles?
                                        </a>
                                    </div>
    
                                    <div id="QuestionThreeContent" class="collapse" aria-labelledby="QuestionThree" data-parent="#faq">
                                        <div class="card-body">
                                            <p>Yes. We can quality check your citations even if they are published in paywalled journals.</p>
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="faqContainer">
                                <div class="card">
                                    <div class="card-header" id="QuestionTwo">
                                        <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTwoContent" aria-expanded="true"
                                            aria-controls="QuestionTwoContent">
                                            Where can I access Trinka Citation Checker? </a>
                                    </div>
    
                                    <div id="QuestionTwoContent" class="collapse" aria-labelledby="QuestionTwo" data-parent="#faq">
                                        <div class="card-body">
                                            <p>Trinka Citation Checker feature is currently available only on the Trinka Cloud
                                                platform to all users. It will come soon to the Word add-in too. </p>
                                        </div>
                                    </div>
                                </div>
    
                                <div class="card">
                                    <div class="card-header" id="QuestionFour">
                                        <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFourContent" aria-expanded="true"
                                            aria-controls="QuestionFourContent">
                                            Can I share the citation report with my co-authors?
                                        </a>
                                    </div>
    
                                    <div id="QuestionFourContent" class="collapse" aria-labelledby="QuestionFour" data-parent="#faq">
                                        <div class="card-body">
                                            <!-- <p>In addition to all the features you get in Basic, you also get Power Mode with a Premium subscription.  Power Mode provides users with up to 40% more suggestions for their content while considering the context of the writing. Furthermore, </p> -->
                                            <p>Currently, the report is not shareable. We will make that happen in the future! </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- <div class="pricingQuestionAnwser" #target>
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="pricingHeadingQuestion">
                        <h2>Frequently Asked Questions</h2>
                        <div class="HeadingSubLine"></div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-1"></div>
                <div class="col-lg-10">
                    <div class="pricingQuestionsList">
                        <div class="accordion" id="faq">
                            <div class="card">
                                <div class="card-header" id="QuestionOne">
                                    <a href="#" class="btn btn-header-link" data-toggle="collapse" data-target="#QuestionOneContent" aria-expanded="true" aria-controls="QuestionOneContent">
                                        How does Trinka Citation Checker work?</a>
                                </div>

                                <div id="QuestionOneContent" class="collapse show" aria-labelledby="QuestionOne" data-parent="#faq">
                                    <div class="card-body">
                                        <h4>Improve the quality of your citations in 3 simple steps! </h4>
                                        <ol>
                                            <li>Just <a href="https://cloud.trinka.ai/signup" target="_blank" rel="noopener noreferrer">Sign Up</a> for free on Trinka. </li>
                                            <li>Go to the Citation Checker page from the left navigation panel. </li>
                                            <li>Upload your document. You can upload from Google Drive, Dropbox, or your computer. You can also use document already uploaded on Trinka. You will get your report in a few minutes!</li>
                                        </ol>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header" id="QuestionTwo">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTwoContent" aria-expanded="true"
                                        aria-controls="QuestionTwoContent">
                                        Where can I access Trinka Citation Checker? </a>
                                </div>

                                <div id="QuestionTwoContent" class="collapse" aria-labelledby="QuestionTwo" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinka Citation Checker feature is currently available only on the Trinka Cloud
                                            platform to all users. It will come soon to the Word add-in too. </p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionThree">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionThreeContent" aria-expanded="true"
                                        aria-controls="QuestionThreeContent">
                                        Does Trinka review citation to paywalled articles?
                                    </a>
                                </div>

                                <div id="QuestionThreeContent" class="collapse" aria-labelledby="QuestionThree" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Yes. We can quality check your citations even if they are published in paywalled journals.</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionFour">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFourContent" aria-expanded="true"
                                        aria-controls="QuestionFourContent">
                                        Can I share the citation report with my co-authors?
                                    </a>
                                </div>

                                <div id="QuestionFourContent" class="collapse" aria-labelledby="QuestionFour" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Currently, the report is not shareable. We will make that happen in the future! </p>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="col-lg-1"></div>
            </div>
        </div>
    </div> -->


    <div class="otherApps section-pd-sm">
        <div class="trinka_container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="trinka-title text-center">
                        <h3 class="text-white">Use Trinka in Other Apps</h3>
                    </div>
                    <ul>
                        <li>
                            <a [routerLink]="['/trinkacloud']">
                                <div class="app_name_content_overlay"></div>
                                <img src="../../../assets/images/Other_apps_TrinkaCloud.svg" alt="icon">
                                <h3>Cloud</h3>
                            </a>
                        </li>
                        <li>
                            <a  [routerLink]="['/windows-desktop-app']">
                                <div class="app_name_content_overlay"></div>
                                <img src="../../../assets/images/native-app/windows-icon.svg" alt="windows">
                                <h3>Windows App</h3>
                            </a>
                        </li>
                        <li>
                            <a [routerLink]="['/wordplugin']">
                                <div class="app_name_content_overlay"></div>
                                <img src="../../../assets/images/Others_App_MSWord.svg" alt="icon">
                                <h3>MS Word Add-in</h3>
                            </a>
                        </li>
                        <li>
                            <a [routerLink]="['/browser-plugin']">
                                <div class="app_name_content_overlay"></div>
                                <img src="../../../assets/images/other_Apps_browser.svg" alt="icon">
                                <h3>Browser Plug-in</h3>
                            </a>
                        </li>
                        <li>
                            <a [routerLink]="['/enterprise']">
                                <div class="app_name_content_overlay"></div>
                                <img src="../../../assets/images/Other_Apps_enterprise.svg" alt="icon">
                                <h3>Enterprise <small>(API, JS, & On-Premise)</small></h3>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="wordPluginPopup" tabindex="-1" role="dialog" aria-labelledby="wordPluginLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-body" style="padding: 0;">
                <button type="button" id="closedPopup" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <div id="iframeHolder"></div>

                <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/XBuFdCM3xtk"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                <!-- <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/z-TVcRwVp3A"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe> -->
            </div>
        </div>
    </div>
</div>